import { useRef } from 'react';

const TAP_CLICK_SUPPRESS_MS = 800;

/**
 * Sul telefono l'azione resta sul tocco, come su iPhone.
 * Il click sintetico che arriva dopo viene ignorato, così non si attiva due volte.
 * Mouse e trackpad, che non emettono touch, usano il click.
 */
export function useTapBindings() {
    const lastTouchAtRef = useRef(0);

    const bindTap = (handler) => {
        if (typeof handler !== 'function') {
            return {};
        }
        return {
            onTouchStart: (event) => {
                lastTouchAtRef.current = Date.now();
                handler(event);
            },
            onClick: (event) => {
                if (Date.now() - lastTouchAtRef.current < TAP_CLICK_SUPPRESS_MS) {
                    return;
                }
                handler(event);
            },
        };
    };

    const bindTapEnd = (handler) => {
        if (typeof handler !== 'function') {
            return {};
        }
        return {
            onTouchEnd: (event) => {
                lastTouchAtRef.current = Date.now();
                handler(event);
            },
            onClick: (event) => {
                if (Date.now() - lastTouchAtRef.current < TAP_CLICK_SUPPRESS_MS) {
                    return;
                }
                handler(event);
            },
        };
    };

    return { bindTap, bindTapEnd };
}
